import { useContext } from 'react';
import { SentryContext } from 'receivable-invoices-js/react/contexts/sentry';

export function useSentry() {
  const context = useContext(SentryContext);
  if (context === null) {
    throw new Error('useSentry must be used within an SentryProvider');
  }
  return context;
}
